import { VIPChannel } from './VIPChannel'
import { VIPClientType } from './VIPClientType'

const ClientTypeChannelMap = {
  [VIPClientType.External]: VIPChannel.Wholesale,
  [VIPClientType.Internal]: VIPChannel.Retail
}

export default ClientTypeChannelMap
